import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";

function App() {
    return (
        <div className="App dark">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "rgba(15,15,17,0.9)",
                        border: "1px solid rgba(255,255,255,0.1)",
                        color: "#fff",
                        backdropFilter: "blur(12px)",
                    },
                }}
            />
        </div>
    );
}

export default App;
